module.exports = __webpack_public_path__ + "fonts/CCDashDecentW00-Heavy.eb0ce91c.woff2";